import React from 'react';
import Leftbar from '../components/General/Leftbar/page';

export default function DashboardLayout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-dark-100">
      <Leftbar />
      <div className="lg:ml-[80px]">
        {children}
      </div>
    </div>
  );
}
